<template>
  <div class="relative bg-black overflow-hidden" :class="height">
    <img
      v-for="(img, i) in images"
      :src="imageSrc(img, i)"
      :srcset="imageSrcset(img, i)"
      :class="slideClasses(i)"
      :key="i"
      class="slide w-full h-full absolute object-fit-pf"
      :style="styles"
      sizes="100vw"
      :alt="img.alt">
  </div>
</template>


<script>
  import objectFitImages from 'object-fit-images'
  export default {
    data() {
      return {
        timer: null,
        imageLoaded: 1,
        currentIndex: 0,
        nextImage: undefined,
      }
    },

    mounted() {
      if (this.images && this.images.length > 1) {
        this.startSlide();
      }
      objectFitImages();
    },

    methods: {
      slideClasses(index) {
        const maxOpacity = this.darken ? this.darken : 'opacity-100'
        return [
          this.currentIndex == index ? maxOpacity : 'opacity-0'
        ]
      },
      imageSrc(img, index) {
        return (this.imageLoaded >= index) || (this.currentIndex + 1 >= index) ?
          img.src : ''
      },
      imageSrcset(img, index) {
        return (this.imageLoaded >= index) || (this.currentIndex + 1 >= index) ?
          img.srcset : ''
      },
      startSlide() {
        this.timer = setInterval(this.next, 6000);
      },
      next() {
        this.currentIndex = (this.currentIndex + 1) % this.images.length
        this.imageLoaded = Math.max(this.currentIndex + 1, this.imageLoaded)
      },
      prev() {
        this.currentIndex -= 1
      },
    },
    computed: {
    },
    props: {
      'images': Array,
      'darken': String,
      'height': String,
      'styles': String,
    },
  }
</script>

<style lang="scss" scoped>
.slide {
  transition: opacity 1s linear;
}
.object-fit-pf {
  object-fit: cover;
  font-family: 'object-fit: cover;';
}
</style>
